import { BusinessError, sendRequest } from '@mews/framework';

const defaultOptions = {
    accept: 'application/json',
    credentials: 'include',
    autoContentType: true,
};

export const sendControllerRequest = async (actionEndpoint: $TSFixMe, data = {}, options = defaultOptions) =>
    // @ts-expect-error $TSFixMeError: Argument of type '{ accept: string; credentials: string; autoContentType: boolean; }' is not assignable to parameter of ...
    sendRequest(actionEndpoint, options, data)
        .then((response) => {
            if (response.errorMessage) {
                throw new BusinessError(response.errorMessage);
            }

            return response;
        })
        .catch((err) => {
            if (err instanceof BusinessError) {
                throw err;
            } else {
                throw new BusinessError(err);
            }
        });
